import { useNavigate } from 'react-router-dom'
import { Table, Label } from 'reactstrap'
import useForm from '../../CustomHooks/FormHook'
import '../Custom.css'
import StateInput from '../StateInput'
import YearInput from './YearInput'
import CustomSelectList from '../CustomSelectList'
import { initialFormValues, submitFormValues } from '../CustomUtils'
import { enterKeyHandler } from '../../../utils'
import FormSubmitButton from '../FormSubmitButton'
import FormHeading from '../FormHeading'


export default function HistoricalClaimActivityReportForm() {
  console.log('HistoricalClaimActivityReportForm rendered:')

  let init = {
    yearFrom: '',
    yearTo: '',
    product: null,
    state: ''
  }

  const navigate = useNavigate()
  init = initialFormValues('HistoricalClaimActivityReportForm', navigate, init)
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))

  async function submitSearch() {
    submitFormValues('HistoricalClaimActivityReportForm', navigate, inputs, 'reports.claim_activity')
  }

  return (
    <div className="custom-scroll">
      <form onSubmit={handleSubmit}>
        <div>
          <Table className="custom-table custom-form-table" style={{backgroundColor: 'white'}}>
            <FormHeading headingText='H.B. Fuller/TEC Historical Claim Activity Report' colSpan='4' />
            <tbody>
              <tr>
                <td><Label><b>From Year</b></Label></td>
                <td><YearInput name={'yearFrom'} handleChange={handleInputChange} defaultValue={inputs.yearFrom} /></td>
                <td><Label><b>To Year</b></Label></td>
                <td><YearInput name={'yearTo'} selectLast={true} handleChange={handleInputChange} defaultValue={inputs.yearTo} /></td>
              </tr>
              <tr>
                <td colSpan={2}><Label><b>Product</b></Label></td>
                <td colSpan={2}><CustomSelectList modelName="HBFuller" entityName="product" name="product" multiple={true} handleChange={handleInputChange} defaultValue={inputs.product} /></td>
              </tr>
              <tr>
                <td colSpan={2}><Label><b>State</b></Label></td>
                <td colSpan={2}><StateInput multiple={true} handleChange={handleInputChange} defaultValue={inputs.state} /></td>
              </tr>
            </tbody>
          </Table>
        </div>
        <FormSubmitButton label="Search" />
      </form>
    </div >
  )
}